import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '../store';
import { TranslationService } from '../translation.service';
import { TranslatorLanguage } from '../types/translator-language';
import { TranslateResult } from './TranslateResult';

@Injectable()
export class TranslatorToolService extends Store<Array<TranslatorLanguage>> {
  constructor(private http: HttpClient, translationService: TranslationService) {
    super([]);
    translationService.supportedLanguages$.subscribe((languages) =>
      this.setState(languages.map((lang) => ({ isoCode: lang.code, name: lang.language })))
    );
  }

  translate(props: { text: string; sourceLang?: string; targetLang?: string; nativeLang?: string }) {
    const { text, sourceLang, targetLang, nativeLang } = props;
    const encodedText = encodeURI(text);
    let params = new HttpParams().set('word', encodedText);
    if (sourceLang) {
      params = params.set('fromLanguage', sourceLang);
    }
    if (targetLang) {
      params = params.set('language', targetLang);
    }
    if (nativeLang) {
      params = params.set('nativeLang', nativeLang);
    }

    return this.http.get<TranslateResult>('/tools/translate', { params });
  }

  getTranslatorLanguages(): Array<TranslatorLanguage> {
    return this.state;
  }

  isLanguageSupported(isoCode: string) {
    let isSupported = false;
    this.state.forEach((lang) => {
      if (lang.isoCode === isoCode) {
        isSupported = true;
        return;
      }
    });
    return isSupported;
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/translator-tool/translator-tool.service.ts